const ListingsContactNotifier = {
  showAlert(message: string, timeout: number = 5000){

    import(
      "noty"
    )
    .then(({default: Noty}) => {
      new Noty({
        text:         message,
        timeout:      timeout,
        type:         "alert",
        layout:       "bottomLeft",
        theme:        "mint",
        progressBar:  false,
      }).show()
    })
  },
}

export default ListingsContactNotifier
